(function($) {

  $('.pages-faq__question').click(function() {
    $(this).parent().find('.pages-faq__answer').slideToggle(300);
  });

})(jQuery);
